import React, { FC } from 'react'

import { useFormContext } from 'react-hook-form'

import ErrorMessage from 'Components/ErrorMessage'

import FormErrors from '../../FormErrors'

interface Props {
  autoComplete?: string
  id?: string
  label?: string
  required?: boolean
  wrapperClassName?: string
}

const PasswordField: FC<Props> = ({
  required = true,
  autoComplete = 'new-password',
  id = 'customer-password',
  label,
  wrapperClassName,
}) => {
  const { register, errors } = useFormContext()

  return (
    <div className={wrapperClassName}>
      {label ? <label htmlFor={id}>{label}</label> : null}

      <input
        ref={register({
          required: required ? 'Password is required' : false,
          minLength: {
            value: 6,
            message: 'Password min length is 6',
          },
        })}
        autoComplete={autoComplete}
        className="form-control"
        id={id}
        name="password"
        placeholder="Password"
        type="password"
      />
      <ErrorMessage as={FormErrors} errors={errors} name="password" />
    </div>
  )
}

export default PasswordField
